import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const KidsRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/kidsmain/kidsmainslide");
  }, [navigate]);

  return null;
};

export default KidsRedirect;